/* ============================================================================
   LANDING — Apparition au défilement (scroll-reveal) en cascade
   ----------------------------------------------------------------------------
   Révèle en cascade les puces de sport (« Un sport, un terrain reconnaissable »)
   et les cartes (« Ce que fait TactiQ ») quand la section entre à l'écran.

   • L'état initial masqué est gaté par <html class="lp-anim"> : si ce module
     ne s'exécute pas (JS désactivé, erreur), le contenu reste visible.
   • Respecte prefers-reduced-motion et retombe proprement sans
     IntersectionObserver : tout est affiché d'emblée.
   • Le décalage en cascade est appliqué à la révélation (setTimeout), pas via
     transition-delay, pour ne pas ralentir les micro-interactions au survol.
   ========================================================================== */
(function () {
  const doc = document;
  const reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Groupes révélés en cascade : sélecteur -> pas de décalage (ms)
  const groups = [
    { items: ".lp-chips li", step: 45 },
    { items: ".lp-features .lp-card", step: 70 },
  ];

  function collect() {
    const els = [];
    for (const g of groups) {
      doc.querySelectorAll(g.items).forEach((el, i) => {
        el._revealDelay = Math.min(i, 12) * g.step; // plafonné pour la fin de liste
        els.push(el);
      });
    }
    return els;
  }

  function start() {
    const els = collect();
    if (!els.length) return;

    // Mouvement réduit ou pas d'observateur : on affiche tout immédiatement.
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }

    // Active l'état initial masqué (voir styles.css : html.lp-anim …).
    doc.documentElement.classList.add("lp-anim");

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target;
          window.setTimeout(
            () => el.classList.add("is-visible"),
            el._revealDelay || 0
          );
          obs.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -8% 0px" }
    );

    els.forEach((el) => io.observe(el));
  }

  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
